import {
  _getSpaceTableData,
  _getProductTableData,
  _downloadStatistics
} from '@/api/Statistics'
import {
  catchErr
} from '@/utils/utils'
import {
  Message
} from 'element-ui'
import router from '@/router'


export default {

  async getSpaceTableData_A({
    state,
    commit
  }) {
    let [err, res] = await catchErr(_getSpaceTableData({
      data: state.searchData
    }));
    let searchingCount = state.searchingCount;
    if (err) {
      Message.error(err.message || '系统异常');
      commit("SETOPTIONS", {
        arrSpaces: [],
        searchingCount: searchingCount - 1
      })
    } else if (res) {
      commit("SETOPTIONS", {
        arrSpaces: res.data,
        searchingCount: searchingCount - 1
      })
    }
    return;
  },
  async getProductTableData_A({
    state,
    commit
  }) {
    let [err, res] = await catchErr(_getProductTableData({
      data: state.searchData
    }));
    let searchingCount = state.searchingCount;
    if (err) {
      Message.error(err.message || '系统异常');
      commit("SETOPTIONS", {
        arrProducts: [],
        searchingCount: searchingCount - 1
      })
    } else if (res) {
      let searchingCount = state.searchingCount;
      commit("SETOPTIONS", {
        arrProducts: res.data,
        searchingCount: searchingCount - 1
      })
    }
    return;
  },

  async searchTable_A({
    dispatch,
    commit
  }) {
    commit("SETOPTIONS", {
      searchingCount: 2,
      arrSpaces: [],
      arrProducts: [],
      arrSpaceEchartObj: [],
      arrProductEchartObj: [],

    })

    dispatch("getSpaceTableData_A");
    dispatch("getProductTableData_A");

    return;
  },

  async downloadStatistics_A({
    state,
    commit
  }) {
    let downloadData = state.downloadData;
    let params = {
      startDate: downloadData.dateRange[0],
      endDate: downloadData.dateRange[1],
      dmCount: downloadData.space ? 1 : 0,
      productCount: downloadData.product ? 1 : 0
    }
    let [err, res] = await catchErr(_downloadStatistics({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.data.type === "application/binary") {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
        window.URL = window.URL || window.webkitURL;
        let datav = URL.createObjectURL(blob);
        let downA = document.createElement("a");
        downA.href = datav;
        downA.download = decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        downA.click();
        window.URL.revokeObjectURL(datav);
      } else if (res.data.type === "application/json") {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
        var reader = new FileReader();
        reader.onload = function (event) {
          var content = reader.result;
          let dataJson = JSON.parse(content)
          switch (dataJson.status) {
            case 1001:
              Message.error("请求失败");
              break;
            case 1002:
              Message.error("请求参数错误");
              break
            case 1005:
              Message.error("权限不足");
              break;
            case 1008:
              Message.error("您点的太快了，请稍后再试");
              break;
            case 1006:
              window.sessionStorage.clear()
              router.replace({
                path: "/userlogin"
              });
              break;
            case 1027:
              Message.error(dataJson.message);
              window.sessionStorage.clear()
              router.replace({
                path: "/userlogin"
              });
              break;
            case 1046:
              Message.error("统计导出数据为空");
              break;
            default:
              Message.error(dataJson.message || "系统异常" );
          }
        };
        reader.readAsText(blob);
      } else {
        Message.error("系统异常")
      }


    }
    return;
  },

}



// WEBPACK FOOTER //
// ./src/store/modules/Statistics/actions.js